import {environment} from "environments";

(() => {
  class NewUserController {
    constructor($state, toastr, Notifications, Users) {
      'ngInject';

      Object.assign(this, {
        $state,
        toastr,
        Notifications,
        Users,
        user: {},
        roles: Users.ROLES,
        genders: Users.GENDERS,
        LMNUK_1798: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
      });

      this.userTitles = ["Canon",
        "Captain",
        "Dame",
        "Dr",
        "Father",
        "Lady",
        "Lieutenant",
        "Lord",
        "Madam",
        "Major",
        "Master",
        "Miss",
        "Mr",
        "Mrs",
        "Ms",
        "Mx",
        "Professor",
        "Reverend",
        "Sergeant",
        "Sir",
        "Sister",
        "Unknown"]

    }

    createUser() {
      try {
        this.creating = true;
        this.Users.create(this.user).then(() => {
          this.toastr.success(this.Notifications.users.createSuccess);
          this.$state.go('users');
        }).catch(err => {
          if (err.status === 409) {
            this.toastr.error(this.Notifications.users.emailInUse);
          } else {
            _.each(err.data.message.summary, errMsg => {
              this.toastr.error(errMsg);
            });
          }
        }).finally(() => {
          this.creating = false;
        });
      } catch (e) {
        this.creating = false;

        if (e.message === 'Invalid Email') {
          this.toastr.error(this.Notifications.users.invalidEmail);
        }
      }
    }

  }

  NewUserController.$inject = ["$state", "toastr", "Notifications", "Users"];
  angular.module('pims').controller('NewUserController', NewUserController);
})();
